module.exports = __webpack_public_path__ + "img/5f7de63.png";